// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-column-stacked';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.576 17.424h16.848M5.472 7.128v10.296H2.088V7.128c0-.144.072-.288.144-.432.144-.144.288-.144.432-.144h2.232c.144 0 .288.072.432.144.072.144.144.288.144.432zm5.616 3.024v7.272H7.704v-7.272c0-.144.072-.288.144-.432.144-.144.288-.144.432-.144h2.232c.144 0 .288.072.432.144.072.144.144.288.144.432zm5.616-6.768v14.04H13.32V3.384c0-.144.072-.288.144-.432.144-.144.288-.144.432-.144h2.232c.144 0 .288.072.432.144.072.144.144.288.144.432zM2.088 9.936h3.384m2.232 2.088h3.384m2.232-4.032h3.384m-3.384 3.096h3.384m-9 3.456h3.384m-9-1.008h3.384'
  />
);

export const viewBox = '0 0 18 18';
